import React, { useEffect, useState } from 'react';
import classes from "./HomePage.module.css";
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'primereact/button';
import { Calendar } from "primereact/calendar";
import moment from "moment-timezone";
import { DataTable } from "primereact/datatable";
import { Column } from 'primereact/column';
import Layout from '../components/Layout';
import { toast } from 'react-toastify';
import { removeToken } from '../store/slices/tokenSlice';
import { useNavigate } from 'react-router-dom';
import Spinner from '../components/Spinner';
import { deletePublisherApi, getPublisherApi, getServicesApi, togglePublisherApi } from '../http/http';
import { Message } from 'primereact/message';
import { InputSwitch } from 'primereact/inputswitch';
import AddPublisherModal from '../components/AddPublisherModal';
import EditPublisherModal from '../components/EditPublisherModal';
import { confirmPopup } from 'primereact/confirmpopup';
import DeletePublisherModal from '../components/DeletePublisherModal';
import DummyHitModal from '../components/DummyHitModal';

const HomePage = () => {
    const { token } = useSelector(state => state?.tokenSlice);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [publisherLoading, setPublisherLoading] = useState(false);
    const [services, setServices] = useState([]);
    const [selectedService, setSelectedService] = useState(null);
    const [publishers, setPublishers] = useState([]);
    const [fetchedPublisher, setFetchedPublisher] = useState(false);
    const [publisherModal, setPublisherModal] = useState({ state: false, serviceDetails: null });
    const [editPublisherModal, setEditPublisherModal] = useState({ state: false, serviceDetails: null });

    const [deletePublisherModal, setDeletePublisherModal] = useState({ state: false, details: null });
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [dummyHitModal, setDummyHitModal] = useState({ state: false, details: null });

    const deletePublisher = async () => {
        try {
            setDeleteLoading(true);
            await deletePublisherApi({ pub_ref_id: deletePublisherModal?.details?.pub_ref_id }, token);
            await handleServiceClick(selectedService);
            setDeleteLoading(false);
            setDeletePublisherModal({ state: false, details: null });
        } catch (error) {
            console.log(error, 'error');
            setDeleteLoading(false);
            if (error?.response?.status == 403) {
                dispatch(removeToken());
                toast.error("Login Again!");
                navigate('/');
            }
            else {
                toast.error(error?.response?.data?.message || "Something Went Wrong!");
            }
        }
    }

    const togglePublisher = async (pub_ref_id) => {
        try {
            await togglePublisherApi({ pub_ref_id }, token);
            await handleServiceClick(selectedService);
        } catch (error) {
            if (error?.response?.status == 403) {
                dispatch(removeToken());
                toast.error("Login Again!");
                navigate('/');
            }
            else {
                toast.error(error?.response?.data?.message || "Something Went Wrong!");
            }
        }
    }

    const getServices = async () => {
        try {
            setLoading(true);
            const response = await getServicesApi(token);
            setServices(response?.data?.services);
            setLoading(false);

        } catch (error) {
            setLoading(false);
            if (error?.response?.status == 403) {
                dispatch(removeToken());
                toast.error("Login Again!");
                navigate('/');
            }
            else {
                toast.error(error?.response?.data?.message || "Something Went Wrong!");
            }
        }
    }

    useEffect(() => {
        getServices();
    }, []);

    const handleServiceClick = async (data) => {
        try {
            setSelectedService(data);
            setPublishers([]);
            setPublisherLoading(true);
            setFetchedPublisher(false);
            const response = await getPublisherApi(data?.id, token);
            setFetchedPublisher(true);
            setPublisherLoading(false);
            setPublishers(response?.data?.publishers);
        } catch (error) {
            setPublisherLoading(false);
            if (error?.response?.status == 403) {
                dispatch(removeToken());
                toast.error("Login Again!");
                navigate('/');
            }
            else {
                toast.error(error?.response?.data?.message || "Something Went Wrong!");
            }
        }
    }

    console.log(deletePublisherModal, 'p');

    const copyToClipboard = async (text) => {
        const value = text ?? "";
        try {
            if (navigator.clipboard && window.isSecureContext) {
                await navigator.clipboard.writeText(value);
            } else {
                // Fallback for non-HTTPS
                const ta = document.createElement("textarea");
                ta.value = value;
                ta.style.position = "fixed";
                ta.style.left = "-9999px";
                document.body.appendChild(ta);
                ta.select();
                document.execCommand("copy");
                document.body.removeChild(ta);
            }
            toast.success("Promotion URL copied");
        } catch (e) {
            toast.error("Copy failed");
        }
    };


    return (
        <>
            <Layout active={0}>
                <Message severity="info" text="Services" style={{ width: "100%", padding: "14px 10px", background: "none", border: "2px solid #E6F0FE", justifyContent: "flex-start" }} />
                {loading ?
                    <>
                        <Spinner />
                    </>
                    : (
                        <>
                            <div className={classes.container}>
                                {services.length > 0 && services.map((data, i) => {
                                    return (
                                        <button type='button' key={i} className={`${classes.service_btn} ${selectedService?.id == data?.id && classes.active}`} onClick={() => {
                                            handleServiceClick(data)
                                        }}>
                                            {data?.service_name}
                                        </button>
                                    )
                                })}
                            </div>
                            {publisherLoading ? <Spinner /> : fetchedPublisher && <>
                                <Message severity="info" text="Publishers" style={{ width: "100%", background: "none", border: "2px solid #E6F0FE", padding: "14px 10px", justifyContent: "flex-start" }} />
                                <button type='button' className={classes.add_publisher}
                                    onClick={() => {
                                        setPublisherModal({
                                            state: true,
                                            serviceDetails: selectedService
                                        })
                                    }}
                                >
                                    Add Publisher
                                </button>
                                <div className={classes.table_container}>
                                    <DataTable
                                        value={[...publishers]}
                                        emptyMessage="No data found"
                                        showGridlines
                                        responsive
                                        scrollable
                                        scrollDirection="both"
                                        scrollHeight="500px"
                                        rows={40}
                                        paginator
                                    >
                                        <Column field="pub_name" header="Publisher Name" />
                                        <Column
                                            field="service_name"
                                            header="Service Name"
                                        />
                                        <Column
                                            field="service_url"
                                            header="Service Url"
                                        />
                                        <Column
                                            field="postback_url"
                                            header="Postback Url"

                                        />
                                        <Column
                                            field="promotion_url"
                                            header="Promotion Url"
                                            body={(rowData) => (
                                                <div className={classes.promotion_url}>
                                                    <p>
                                                        {rowData?.promotion_url}
                                                    </p>

                                                    <Button
                                                        icon="pi pi-copy"
                                                        aria-label="Copy promotion URL"
                                                        rounded
                                                        text
                                                        size='large'
                                                        onClick={() => copyToClipboard(rowData?.promotion_url)}
                                                        tooltip="Copy URL"
                                                        tooltipOptions={{ position: "left" }}
                                                        style={{ color: "#696CFF" }}
                                                    />

                                                </div>
                                            )
                                            }

                                        />
                                        <Column
                                            field="operator"
                                            header="Operator"

                                        />
                                        <Column
                                            field="country"
                                            header="Country"

                                        />
                                        <Column
                                            field="amount"
                                            header="Amount"
                                        />
                                        <Column
                                            field="daily_cap"
                                            header="Daily Cap"
                                        />
                                        <Column
                                            field="skip_value"
                                            header="Skip"
                                        />
                                        <Column field="edit"
                                            header="Edit"
                                            body={(rowData) => (
                                                <button type='button' className={classes.edit_btn} onClick={() => setEditPublisherModal({ state: true, publisherDetails: rowData })}>
                                                    Edit
                                                </button>
                                            )
                                            }
                                        />
                                        <Column field="delete"
                                            header="Delete"
                                            body={(rowData) => (
                                                <button type='button' className={classes.delete_btn} onClick={() => {
                                                    setDeletePublisherModal({ state: true, details: rowData })
                                                }}>
                                                    Delete
                                                </button>
                                            )
                                            }
                                        />
                                        <Column
                                            field="isEnable"
                                            header="Enable"
                                            body={(rowData) => {
                                                console.log(rowData?.isEnable, 'rd');
                                                return (
                                                    <InputSwitch checked={rowData?.isEnable == 1 ? true : false}
                                                        onChange={() => togglePublisher(rowData?.pub_ref_id)}
                                                    />
                                                )
                                            }}
                                        />
                                        <Column
                                            field="hit"
                                            header="Dummy Hit"
                                            bodyStyle={{
                                                minWidth: "140px"
                                            }}
                                            body={(rowData) => {
                                                return (
                                                    <button type='button' className={classes.edit_btn}
                                                        onClick={() => {
                                                            setDummyHitModal({ state: true, details: rowData })
                                                        }}
                                                    >
                                                        Dummy Hit
                                                    </button>
                                                )
                                            }}
                                        />
                                    </DataTable>
                                </div>
                            </>
                            }
                        </>
                    )
                }
                <AddPublisherModal publisherModal={publisherModal} setPublisherModal={setPublisherModal} handleServiceClick={handleServiceClick} />
                <EditPublisherModal editPublisherModal={editPublisherModal} setEditPublisherModal={setEditPublisherModal} serviceDetails={selectedService} handleServiceClick={handleServiceClick} />
                <DummyHitModal dummyHitModal={dummyHitModal} setDummyHitModal={setDummyHitModal} token={token} />
                {deletePublisherModal?.state && <DeletePublisherModal deleteLoading={deleteLoading} deletePublisher={deletePublisher} publisherName={deletePublisherModal?.details?.pub_name} setDeletePublisherModal={setDeletePublisherModal} />}
            </Layout>

        </>

    )
}

export default HomePage;